const Gallery = () => {
  const galleryImages = [
    {
      src: "/ferailleur.webp",
      alt: "Enlèvement d'un véhicule hors d'usage à Saint-Étienne",
      caption: "Enlèvement d'épave dans la Loire et à Saint-Étienne",
      width: 800,
      height: 600,
      aspectRatio: "4/3"
    },
    {
      src: "/car-hero.webp",
      alt: "Rachat de métaux et ferraille à Saint-Étienne",
      caption: "Rachat de métaux (cuivre, laiton, aluminium)",
      width: 800,
      height: 600,
      aspectRatio: "4/3"
    },
    {
      src: "/ferailleur-2.webp",
      alt: "Équipe professionnelle de ferrailleur épaviste à Saint-Étienne",
      caption: "Notre équipe de ferrailleur épaviste à votre service",
      width: 800,
      height: 600,
      aspectRatio: "4/3"
    },
  ]

  return (
    <section id="galerie" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Notre Travail de Ferrailleur Épaviste à Saint-Étienne en Images</h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Découvrez notre activité de ferrailleur et d'épaviste à Saint-Étienne et à travers ces quelques images de nos interventions
            dans la Loire, la Haute-Loire et le Rhône.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {galleryImages.map((image, index) => (
            <div key={index} className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div style={{ position: 'relative', paddingBottom: `${(image.height / image.width) * 100}%` }}>
                <img 
                  src={image.src || "/placeholder.svg"} 
                  alt={image.alt} 
                  className="absolute inset-0 w-full h-full object-cover"
                  width={image.width}
                  height={image.height}
                  loading={index === 0 ? "eager" : "lazy"}
                  fetchPriority={index === 0 ? "high" : "auto"}
                  style={{ aspectRatio: image.aspectRatio }}
                />
              </div>
              <div className="p-4 bg-white">
                <p className="text-gray-700 text-center">{image.caption}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Gallery
